import React from 'react';
import styles from '../IntradaySignalTestPage.module.css';
import { IntradaySignalUpdate } from '../../types/trading';
import { ScheduleFormState } from './signalConfig';
import { FrequencyControls } from './FrequencyControls';

interface ScheduleControlsProps {
  form: ScheduleFormState;
  onChange: (form: ScheduleFormState) => void;
}

export const ScheduleControls: React.FC<ScheduleControlsProps> = ({ form, onChange }) => (
  <FrequencyControls
    value={form.frequency}
    onChange={(frequency) => onChange({ ...form, frequency })}
  />
);

interface ScheduleResultsProps {
  update: IntradaySignalUpdate | null;
}

export const ScheduleResults: React.FC<ScheduleResultsProps> = ({ update }) => {
  const lastSampled = update?.last_sampled_at ?? null;
  const nextSample = update?.next_sample_at ?? null;
  return (
    <div className={styles.results}>
      <div className={styles.arrayCard}>
        <h2>Schedule Gate</h2>
        <p>Last Sampled: {lastSampled ?? '--'}</p>
        <p>Next Sample: {nextSample ?? '--'}</p>
        <p>Gate Open: {update?.due ? 'yes' : 'no'}</p>
      </div>
    </div>
  );
};
